
import { Alert, Button, Container, Grid, Paper, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import imageCompression from 'browser-image-compression'
import styled from '@emotion/styled';
import { toHaveStyle } from '@testing-library/jest-dom/matchers';
import toast from 'react-hot-toast';


const ImageCompresser = () => {
      const [origImage, setOrigImage] = useState("")
      const [origImageFile, setOrigImageFile] = useState("")
      const [fileName, setFileName] = useState("")
      const [compressedImage, setCompressedImage] = useState("")

      const placeholderImageUrl="https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg"
      
      const handle = (e) => {
        const imageFile = e.target.files[0];
        setOrigImage(imageFile);
        setOrigImageFile(URL.createObjectURL(imageFile));
        setFileName(imageFile.name)
        setCompressedImage("")
      }
    
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));
    
    const handleCompressImage = (e) => {
        e.preventDefault()

        const options = {
            maxSizeMb: 1,
            useWebWorker:true,
        }

        
        if(options.maxSizeMb >= origImage/1024) {
            alert('Image is too small')
        }

        let output;
        imageCompression(origImage, options).then((s) => {
            output=s
            const downloadLink = URL.createObjectURL(output)
            setCompressedImage(downloadLink)
        })
        if(isSm || isXs) {
            toast.success('Scroll down to download the image ⬇️')
        }
        
    }


  return (
    <>
        <Container sx={{textAlign:'center', my:5, display:'flex', flexDirection:'column', alignItems:'center'}}>
            <Button variant="contained" component="label" sx={{width:'200px'}}>
                Upload Image
                <input type="file" hidden accept="image/*" onChange={(e) => handle(e)} />
            </Button>
            <br/>
            {origImageFile && 
                <>
                <Button sx={{width:'200px', mb:2}} variant="contained" color="secondary" onClick={(e)=>{handleCompressImage(e)}}>Compress Image</Button>
                <Alert severity="info">You may not see the full image on the mobile because of overflowing width or height</Alert>
                </>          
            }
        </Container>

        <Grid container sx={{margin:'0 auto', overflow:'hidden'}}>
            <Grid item xs={12} md={12} lg={6} sx={{textAlign:'center', border:'1px solid #eee', height:'500px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                {origImageFile ? <img alt="uploaded pic" style={{height:'auto', width:'100%', objectFit:'cover', objectPosition
            :'center center'}} src={origImageFile}/> :  <img alt="placeholder" style={{width:'300px'}} src={placeholderImageUrl}/>}
            </Grid>
            <Grid item xs={12} md={12} lg={6} sx={{textAlign:'center', border:'1px solid #eee',height:'500px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                {compressedImage ? <img alt="compressed pic" style={{height:'auto', width:'100%', objectFit:'cover', objectPosition
            :'center center'}} src={compressedImage}/> :  <img alt="placeholder" style={{width:'300px'}} src={placeholderImageUrl}/>}
            </Grid>
        </Grid>
        {compressedImage &&
        <Container sx={{textAlign:'center', my:5, display:'flex', flexDirection:'column', alignItems:'center'}}>
            <Alert sx={{mb:2}}>Your compressed image is ready to download</Alert>
            <Button variant="contained"><a style={{color:"#fff", textDecoration:'none'}} href={compressedImage} download={fileName}>Download</a></Button>
        </Container>} 
    </>
    )  
}

export default ImageCompresser